@import "@/scss/use-bootstrap-mixins.scss";

span.header_text {
  color: $primaryOnBackground !important;
  margin: 0 !important;
  font-size: calc(1.3rem + 0.6vw);
  font-weight: 600 !important;
}

.form_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;

  @include media-breakpoint-up(lg) {
    flex-direction: row;
    gap: 12px;
  }

  input {
    flex: 1;
    width: 100%;
    border: 1px solid #d0d0d0;
    border-radius: 4px !important;
    padding: 13px 15px;
    font-size: 14px;
    background-color: #fff;
  }
}

.copy {
  font-style: italic;
  font-size: 12px;
  margin-top: 8px;
}
